import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface DividerLineDivProps {
  className?: string
  vertical?: boolean
  noMargin?: boolean
}

const DividerLineDiv: React.FC<DividerLineDivProps> = (props) => {
  return (
    <div
      className={props.className}
      css={css`
        ${props.vertical
          ? css`
              border-left: 1px solid ${styleConstants.colors.gray_medium};
            `
          : css`
              border-bottom: 1px solid ${styleConstants.colors.gray_medium};
            `}
        ${props.vertical
          ? css`
              width: unset;
            `
          : css`
              width: 100%;
            `}
        ${!props.noMargin &&
        css`
          margin: 0px 16px;
        `}
      `}
    />
  )
}

export default DividerLineDiv
